import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {user} from "../../../models/user";
import {UserService} from "../../../services/user.service";
import {Localiser} from "../../../services/localiser";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ResetPasswordComponent>, @Inject(MAT_DIALOG_DATA) public data: {usuario: user},
              private userService: UserService, public localiser: Localiser) { }

  ngOnInit(): void {
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  resetPassword() {
    this.userService.resetPassword(this.data.usuario.idUsuario).subscribe(result => {
      this.onCancelClick();
    })
  }

}
